module.exports = __webpack_public_path__ + "static/violeta-gaina-ef871e6f33e3b833c16bb4c8e13bb242.jpg";